import { render, staticRenderFns } from "./DisplayTextarea.vue?vue&type=template&id=423cf7c2&scoped=true&"
import script from "./DisplayTextarea.vue?vue&type=script&lang=js&"
export * from "./DisplayTextarea.vue?vue&type=script&lang=js&"
import style0 from "./DisplayTextarea.vue?vue&type=style&index=0&id=423cf7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cf7c2",
  null
  
)

export default component.exports